(function($) {

    function addCollapse() {
        if($(window).width() < 768) {
            $(".Content-text--wrapper p:first").nextAll().wrapAll('<div class="Content-collapse CollapseContent--collapse-body is-CollapseContent--hidden" data-collapsecontent-body />');

            $( '<div class="Content-collapse--link_wrapper"><button type="button" class="Content-collapse--link" data-collapsecontent-trigger>Learn</button></div>' ).insertAfter( '.Content-collapse' );
        }
    }


    function equalizeHeights(selector) {
        var heights = new Array();

        // Loop to get all element heights
        $(selector).each(function() {

            // Need to let sizes be whatever they want so no overflow on resize
            $(this).css('min-height', '0');
            $(this).css('max-height', 'none');
            $(this).css('height', 'auto');

            // Then add size (no units) to array
            heights.push($(this).outerHeight());
        });

        // Find max height of all elements
        var max = Math.max.apply( Math, heights );

        if ($(window).width() > 767) {
            $(selector).each(function() {
                $(this).css('height', max + 'px');
            });
        }
    }


    function equalizeHeightsImg() {
        if( $('.Team').length ) {
            var imgHeight = Math.max.apply(Math, $('.Team-block--image_wrapper').map (
                function() {
                    var totImgHeight = 0;

                    $(this).each(function() {
                       totImgHeight += $(this).outerHeight();
                    });

                    return totImgHeight;
                }
            ));

            $('.Team-block--apply').height(imgHeight);
        }
    }

    $('.Team-blocks--modal').on('offcanvas-open', function() {
        $('body').addClass('hidden');
    });
    $('.Team-blocks--modal').on('offcanvas-dismiss', function() {
        $('body').removeClass('hidden');
    });

    addCollapse();

    $(window).load(function() {
        // Fix heights on page load
        equalizeHeights($('.Team-block--member'));
        equalizeHeightsImg();

        // Fix heights on window resize
        var iv = null;
        $(window).resize(function() {
            if(iv !== null) {
                window.clearTimeout(iv);
            }

            // Needs to be a timeout function so it doesn't fire every ms of resize
            iv = setTimeout(function() {
                equalizeHeights($('.Team-block--member'));
                equalizeHeightsImg();
            }, 120);
        });
	});

    $(document).ready(function() {
        $('.Statistic-contents').css('visibility', 'visible');
    });


}(jQuery));
